import React, { useState } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import PropTypes from "prop-types";

import SVG from "components/base/SVG";
import Confirm from "app/components/Confirm";
import { dropWrapper } from "utils/DOM/dragDrop";

import css from "./style.scss";

//import plusIcon from '../../../assets/images/plus.svg';

const LeftPart = (props) => {
  const [dropping, setDropping] = useState(false);

  const handleDeleteClick = () => {
    props.alert(
      "Please drag any groups or records here that you would like to remove.",
    );
  };

  const handleDragEnter = () => {
    setDropping(true);
  };

  const dragTimeoutRef = React.useRef(null);

  const handleDragLeave = (ev) => {
    // Clear any existing timeout
    if (dragTimeoutRef.current) {
      clearTimeout(dragTimeoutRef.current);
    }

    // Set a timeout to reset dropping state
    // This ensures we reset even if dragend doesn't fire
    dragTimeoutRef.current = setTimeout(() => {
      setDropping(false);
    }, 50);
  };

  const handleDragOver = (ev) => {
    ev.preventDefault();


    if (dragTimeoutRef.current) {
      clearTimeout(dragTimeoutRef.current);
      dragTimeoutRef.current = null;
    }

    setDropping(true);
  };

  const handleDragEnd = () => {

    if (dragTimeoutRef.current) {
      clearTimeout(dragTimeoutRef.current);
    }
    setDropping(false);
  };



  React.useEffect(() => {
    // Add global dragend listener to reset dropping state
    const handleGlobalDragEnd = () => {
      setDropping(false);
    };

    document.addEventListener("dragend", handleGlobalDragEnd);

    return () => {
      document.removeEventListener("dragend", handleGlobalDragEnd);
      if (dragTimeoutRef.current) {
        clearTimeout(dragTimeoutRef.current);
      }
    };
  }, []);

  const {
    children,
    caption,
    onDeleteDrop,
    allowDrop,
    onAddClick,
    addLabel,
    addIcon,
    headerClass,
  } = props;

  return (
    <div className={css.leftPanelWrapper}>
      <div className={classNames(css.headerpanel, headerClass)}>
        <p className={css.title}>{caption}</p>
        <div className={css.actions}>
          {!onDeleteDrop ? null : (
            <div
              className={classNames(css.action, { [css.dropping]: dropping })}
              onClick={handleDeleteClick}
              onDragEnter={allowDrop && handleDragEnter}
              onDragLeave={allowDrop && handleDragLeave}
              onDragOver={allowDrop && handleDragOver}
              onDragEnd={allowDrop && handleDragEnd}
              onDrop={allowDrop && ((ev) => {
                setDropping(false);
                props.onDeleteDrop(ev);
              })}
            >
              <SVG
                icon={`trash${dropping ? "Open" : ""}`}
                height="24"
                width="24"
              />
            </div>
          )}
        </div>
        {!onAddClick ? null : (
          <button
            type="button"
            className={classNames(css.btn_primary)}
            onClick={onAddClick}
          >
            {addIcon && (
              <span className={css.plusIcon}>
                <img src={addIcon} alt="" />
              </span>
            )}
            {addLabel}
          </button>
        )}
      </div>
      <div className={css.content}>{children}</div>
    </div>
  );
};

LeftPart.propTypes = {
  caption: PropTypes.string.isRequired,
  headerClass: PropTypes.string,
  addLabel: PropTypes.string,
  addIcon: PropTypes.string,
  onAddClick: PropTypes.func,
  onDeleteDrop: PropTypes.func,
  allowDrop: PropTypes.bool,
};

LeftPart.defaultProps = {
  allowDrop: false,
  addLabel: "New",
};

export default connect(null, { alert: Confirm.alert })(LeftPart);
